import { RouteComponentProps } from "@talentpair/routing";

export const historyGoBack =
  ({ history }: RouteComponentProps) =>
  (): void =>
    history.goBack();
